import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Pipe, PipeTransform, SecurityContext, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'secureResourceUrl',
})
export class SecureResourceUrlPipe implements PipeTransform {
  private readonly http = inject(HttpClient);
  private readonly sanitizer = inject(DomSanitizer);

  transform(url: string): Observable<SafeResourceUrl> {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');
    const sanitizedUrl = this.sanitizer.sanitize(SecurityContext.URL, url);
    if (!sanitizedUrl) {
      throw new Error('Invalid URL for secure resource');
    }

    return this.http
      .get(sanitizedUrl, {
        headers: headers,
        responseType: 'blob',
      })
      .pipe(
        map((val: Blob) =>
          this.sanitizer.bypassSecurityTrustResourceUrl(
            URL.createObjectURL(val)
          )
        )
      );
  }
}
